export default __webpack_public_path__ + "static/media/fire1.79cb8b68.png";